
import XHeader from 'vux/src/components/x-header/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {mapState,mapMutations} from 'vuex'
import { financialList, financialInfo } from '../service/getdata'
export default{
components:{
XHeader,
Toast
},
data(){
return{
msg: "",
show: false,
list: [], //质押列表
info: {}
}
},
computed:{
...mapState(['token'])
},
created(){
this.SETTOKEN()
this.getData()
this.getInfo()
},
methods:{
...mapMutations(['SETUSERDETAIL','SETUSER','SETTOKEN',"SETUSERNAME"]),
getData(){
var that = this
this.$Loading()
financialList({token: this.token}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){
that.list = res.data
}else if(res.status=='-1'){
that.SETUSERNAME(undefined)
that.$router.push('/pages/login')

}
}.bind(this),function(){
that.$Loading.close()
console.log("error")
})
},
getInfo(){
var that = this
this.$Loading()
financialInfo({token: this.token}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){
that.info = res.data
}else if(res.status=='-1'){
that.SETUSERNAME(undefined)
that.$router.push('/pages/login')

}
}.bind(this),function(){
that.$Loading.close()
console.log("error")
})
},
sendMsg(content) {
this.msg = content;
this.show = true;
},


},
watch:{

}
}



// WEBPACK FOOTER //
// ./src/pages/fund.vue